export default (value) => {
  const url = value.toLowerCase()
  const regex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/g
  const isValid = !!url.match(regex)
  if (isValid) {
    // if (value.match(/^(http|https)/)) window.open(value, '_blank')
    // else window.open('//' + value, '_blank')
    // const httpOrhttps = value.match(/^(http|https)/) ? true : false
    // ===============================================================
    const httpOrhttps = !!url.match(/^(http|https)/)
    return httpOrhttps
  }
  if (value.includes('mailto')) {
    return true
  }
  return false
}
